/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earth_Day_2025_Impact_Conclude_TitleInputs */

const en_earth_day_2025_impact_conclude_title = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You made an impact that matters!`)
};

const ar_earth_day_2025_impact_conclude_title = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقد أحدثت تأثيراً مهماً!`)
};

const de_earth_day_2025_impact_conclude_title = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast einen Unterschied gemacht, der zählt!`)
};

const es_earth_day_2025_impact_conclude_title = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Has causado un impacto que importa!`)
};

const fr_earth_day_2025_impact_conclude_title = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre contribution fait vraiment la différence !`)
};

const it_earth_day_2025_impact_conclude_title = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai fatto un impatto che conta!`)
};

const ja_earth_day_2025_impact_conclude_title = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたはとても貢献しています！`)
};

const ko_earth_day_2025_impact_conclude_title = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`영향력이 정말 대단해요!`)
};

const pt_br_earth_day_2025_impact_conclude_title = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você causou um impacto significativo!`)
};

const ru_earth_day_2025_impact_conclude_title = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы внесли огромный вклад!`)
};

const th_earth_day_2025_impact_conclude_title = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณได้สร้างผลกระทบที่มีความหมายแท้จริง!`)
};

const tr_earth_day_2025_impact_conclude_title = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önemli bir etki yarattın!`)
};

const zh_cn_earth_day_2025_impact_conclude_title = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你做的事，地球会记得`)
};

const zh_tw_earth_day_2025_impact_conclude_title = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你做的事，地球會記得`)
};

/**
* | output |
* | --- |
* | "You made an impact that matters!" |
*
* @param {Earth_Day_2025_Impact_Conclude_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_impact_conclude_title = /** @type {((inputs?: Earth_Day_2025_Impact_Conclude_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Impact_Conclude_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_impact_conclude_title(inputs)
	if (locale === "ar") return ar_earth_day_2025_impact_conclude_title(inputs)
	if (locale === "de") return de_earth_day_2025_impact_conclude_title(inputs)
	if (locale === "es") return es_earth_day_2025_impact_conclude_title(inputs)
	if (locale === "fr") return fr_earth_day_2025_impact_conclude_title(inputs)
	if (locale === "it") return it_earth_day_2025_impact_conclude_title(inputs)
	if (locale === "ja") return ja_earth_day_2025_impact_conclude_title(inputs)
	if (locale === "ko") return ko_earth_day_2025_impact_conclude_title(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_impact_conclude_title(inputs)
	if (locale === "ru") return ru_earth_day_2025_impact_conclude_title(inputs)
	if (locale === "th") return th_earth_day_2025_impact_conclude_title(inputs)
	if (locale === "tr") return tr_earth_day_2025_impact_conclude_title(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_impact_conclude_title(inputs)
	return zh_tw_earth_day_2025_impact_conclude_title(inputs)
});